import React from "react"
import PropTypes from "prop-types"
import { Modal, Button, Alert } from "components/common"
import { FaEye, FaExternalLinkAlt } from "react-icons/fa"

const TemplatePolicyViewer = ({ show, onHide, asset }) => {
  const previewUrl = asset?.preview_url
  const contentType = asset?.content_type || ""
  const fileName = asset?.name || "Document"

  // Check if the file can be previewed
  const canPreview = contentType.includes("pdf") ||
    contentType.includes("image") ||
    contentType.includes("text")

  const handleOpenInNewTab = () => {
    if (previewUrl) {
      window.open(previewUrl, "_blank")
    }
  }

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      title={(
        <>
          <FaEye className="tw-mr-2" />
          {fileName}
        </>
      )}
      footer={(
        <>
          {previewUrl && (
            <Button
              variant="ghost"
              onClick={handleOpenInNewTab}
            >
              <FaExternalLinkAlt className="tw-mr-2" />
              Open in New Tab
            </Button>
          )}
          <Button variant="secondary" onClick={onHide}>
            Close
          </Button>
        </>
      )}
    >
      <div style={{ height: "80vh" }}>
        {!previewUrl ? (
          <div className="tw-flex tw-items-center tw-justify-center tw-h-full">
            <Alert type="warning">
              <p className="tw-mb-0">No preview available for this file.</p>
            </Alert>
          </div>
        ) : canPreview ? (
          <div className="tw-h-full">
            {contentType.includes("pdf") ? (
              <iframe
                src={previewUrl}
                title={fileName}
                className="tw-w-full tw-h-full"
                style={{ border: "none" }}
              />
            ) : contentType.includes("image") ? (
              <div className="tw-flex tw-items-center tw-justify-center tw-h-full">
                <img
                  src={previewUrl}
                  alt={fileName}
                  style={{ maxWidth: "100%", maxHeight: "100%" }}
                />
              </div>
            ) : contentType.includes("text") ? (
              <iframe
                src={previewUrl}
                title={fileName}
                className="tw-w-full tw-h-full"
                style={{ border: "none" }}
              />
            ) : (
              <div className="tw-flex tw-items-center tw-justify-center tw-h-full">
                <Alert type="warning" className="tw-p-3">
                  <p>This file type cannot be previewed directly.</p>
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={handleOpenInNewTab}
                  >
                    <FaExternalLinkAlt className="tw-mr-2" />
                    Open in New Tab
                  </Button>
                </Alert>
              </div>
            )}
          </div>
        ) : (
          <div className="tw-flex tw-items-center tw-justify-center tw-h-full">
            <Alert type="info">
              <p className="tw-mb-3">
                Preview not available for this file type.
              </p>
              <p className="tw-mb-3">
                For Word/Excel documents, you can try opening in a new tab
                which may trigger a download or external viewer.
              </p>
              <Button
                variant="primary"
                onClick={handleOpenInNewTab}
              >
                <FaExternalLinkAlt className="tw-mr-2" />
                Open in New Tab
              </Button>
            </Alert>
          </div>
        )}
      </div>
    </Modal>
  )
}

TemplatePolicyViewer.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  asset: PropTypes.shape({
    name: PropTypes.string,
    preview_url: PropTypes.string,
    content_type: PropTypes.string
  })
}

export default TemplatePolicyViewer
